import React, { useLayoutEffect, useState } from "react";
import style from "./Screen02.module.css";
import bocica from "../assets/bocica.png";
import bottle from "../assets/bottle.png";
import start from "../assets/start.png";
import startact from "../assets/startact.png";
import flasica from "../assets/flasica.png";
import staklenico from "../assets/staklenico.png";

const Screen02 = ({ phase, setPhase, language, setLanguage }) => {
  const [btn, setBtn] = useState(start);
  const [btnStyle, setBtnStyle] = useState(style.start);
  const [naslov, setNaslov] = useState(bocica);

  const handleBtn = () => {
    setBtnStyle(style.startact);
    setBtn(startact);
  };
  const handleBtnLeave = () => {
    setBtnStyle(style.start);
    setBtn(start);
  };
  const handleBtnClick = () => {
    setPhase(2);
    };
    useLayoutEffect(()=>{
        if(language === "Croatia" || language === "Bosnia"){
            setNaslov(bocica);
        }
        if (language === "Serbia" || language === "Montenegro") {
            setNaslov(flasica);
        }
        if (language === "Slovenia") {
            setNaslov(staklenico);
        }
    },[language])

  return (
    <div>
      <img src={naslov} alt="bocica" className={style.opis} />
      <img src={bottle} alt="bottle" className={style.bottle}  style={{left: language === 'Slovenia' ? "75%" : "68%"}} />
      <img
        src={btn}
        alt="start"
        className={btnStyle}
        onPointerDown={handleBtn}
        onPointerLeave={handleBtnLeave}
        onPointerUp={handleBtnClick}
      />
    </div>
  );
};

export default Screen02;
